export const constants = {
	selector: {
		settingColor: '.js-setting-colors',
		colorContainers: '.js-color-container',
		colorHandlers: 'reporting-color-pickers-change',
		colorPicker: '.js-reporting-color',
		colorValue: '.js-reporting-color-value',
	},
}
